import * as moment from "moment";

const wrapHeaderInQuotes = (value) => `"${value.replace(/"/g, '""')}"`;

export const initialStateObject = {
  orderType: "BOTH",
  state: "",
  city: "",
  fromDate: moment().subtract(90, 'days').format('YYYY-MM-DD'),
  toDate: moment().add(30, 'days').format('YYYY-MM-DD'),
  status: [{ value: "ALL", label: "ALL", }],
  requestType: 'Delivery'
}

export const selectStyle = {
  maxWidth: "200px",
}

export const csvHeaderArray = [
  { id: "OrderId", displayName: "Order Id" },
  { id: "InvoiceNo", displayName: "Invoice No" },
  { id: "InvoiceDate", displayName: "Invoice Date" },
  { id: "PoNumber", displayName: "Po Number" },
  { id: "ReferenceNumber", displayName: "Reference Number" },
  { id: "PostName", displayName: "Post Name" },
  { id: "TransportType", displayName: "Transport Type" },
  { id: 'Material', displayName: 'Material' },
  { id: 'Condition', displayName: 'Condition' },
  { id: 'PalletType', displayName: 'Pallet Type' },
  { id: 'Moisture', displayName: 'Moisture' },
  { id: 'Size', displayName: 'Size' },
  { id: 'Grade', displayName: 'Grade' },
  { id: "Location", displayName: wrapHeaderInQuotes("Location Name, City, State, Zipcode") },
  { id: "Role", displayName: "Role" },
  { id: "OrderType", displayName: "Order Type" },
  { id: "Status", displayName: "Status" },
  { id: 'ClaimDetails', displayName: 'Claim Details(Qty-Issue Type-Claim Status)' },
  { id: "RequestedDate", displayName: "Requested Date" },
  { id: "ActualDeliveryDate", displayName: "Actual Delivery Date" },
  { id: 'PaymentUpdatedDate', displayName: 'Payment Initiated Date' },
  { id: "AcNo", displayName: "My A/c No." },
  { id: "Quantity", displayName: "Quantity" },
  { id: 'PayoutDate', displayName: 'Payout Date' },
  { id: 'PayoutStatus', displayName: 'Payout Status' },
  { id: 'UnitPrice', displayName: 'Unit Price' },
  { id: 'ExtendedAmount', displayName: 'Extended Amount' },
  // { id: 'BuyerDiscount', displayName: 'Buyer Discount Amount' },
  // { id: 'BuyerDiscountedPrice', displayName: 'Discounted Buyer Product Price' },
  { id: 'SellerDiscount', displayName: 'Discount Amount' },
  { id: 'SellerDiscountedPrice', displayName: 'Amount Due after Discount' },
  { id: 'PaymentTerm', displayName: 'Payment Terms' },
  { id: 'PaymentTermDiscount', displayName: 'Payment Terms Discount' },
  { id: 'Tax', displayName: 'Tax' },
  { id: 'OtherFee', displayName: 'Other Fee' }, // this is total seller fee/buyer fee
  { id: 'TotalAmount', displayName: 'Total Amount' }, // this is total amount buyer/seller
  { id: 'BuyerComments', displayName: 'Buyer Comments' },
  { id: 'SellerComments', displayName: 'Seller Comments' },
]

export const pickupCsvHeaderArray = [
  { id: "OrderNo", displayName: "Order Id" },
  { id: "InvoiceNo", displayName: "Invoice No" },
  { id: "InvoiceDate", displayName: "Invoice Date" },
  { id: "PurchaseOrder", displayName: "Po Number" },
  { id: "ReferenceNumber", displayName: "Reference Number" },
  { id: "SupplierReferenceNumber", displayName: "Supplier Ref #" },
  { id: "Type", displayName: "Type" },
  { id: "PickupLocationDetails", displayName: "Pick up Location Name - City - State - Zipcode" },
  { id: "Status", displayName: "Status" },
  { id: "ClaimDetails", displayName: "Claim Details(Qty-Issue Type)" },
  { id: "ReqPickupDate", displayName: "Requested PU Date" },
  { id: "ActualPickupDate", displayName: "Actual PU Date" },
  { id: "PaymentInitiatedDate", displayName: "Payment Initiated Date" },
  { id: "MyAcNo", displayName: "My A/c No." },
  { id: "PalletType", displayName: "Pallet Type" },
  { id: "Quantity", displayName: "Quantity" },
  { id: "UnitPrice", displayName: "Unit Price" },
  { id: "SubTotalAmt", displayName: "Sub total Amount" },
  { id: "ExtendedAmt", displayName: "Extended Amount" },
  { id: 'CollectionTerm', displayName: 'Collection Terms' },
  { id: 'CollectionTermDiscount', displayName: 'Collection Terms Discount' },
  { id: 'BuyerDiscount', displayName: 'Discount Amount' },
  { id: "Tax", displayName: "Tax" },
  { id: "OtherFee", displayName: "Other Fee" },
  { id: "TotalAmt", displayName: "Total Amount" },
  { id: "BuyerComment", displayName: "Buyer Comments" },
  { id: "SellerComment", displayName: "Seller Comments" }
]

export const headerArray = [
  { title: "Order ID", },
  { title: "Invoice No" },
  { title: "Invoice Date" },
  { title: 'Reference Number' },
  { title: "Other Party", },
  { title: "Transport Type" },
  { title: "Order Type", },
  { title: "Status", },
  { title: "Requested Date" },
  { title: "Payment Initiated Date" },
  { title: "My A/c No." },
  { title: "Quantity", },
  { title: "Total Amount" },
]

export const pickupOrderHeaderArray = [
  { title: "Order ID", },
  { title: "Invoice No" },
  { title: "Po. No" },
  { title: 'Reference Number' },
  { title: "Pickup Location", },
  { title: "Status", },
  { title: "Requested Date" },
  { title: "Payment Initiated Date" },
  { title: "My A/c No.", },
  { title: "Total Amount", },
]

export const requestTypeList = [
  { value: 'Delivery', label: 'Delivery' },
  { value: 'Pickup', label: 'Pickup' }
]

export const orderStatusList = [
  { value: "ALL", label: "ALL", },
  { value: "ASSIGNED", label: "ASSIGNED", },
  { value: "SHIPPED", label: "SHIPPED", },
  { value: "DELIVERED", label: "DELIVERED", },
  { value: "CLAIM", label: "CLAIM", },
  { value: "HOLD", label: "HOLD" },
  { value: "CANCELLED", label: "CANCELED", },
  { value: "COMPLETE", label: "COMPLETED", },
]

export const pickupStatusList = [
  { value: "ALL", label: "ALL", },
  { value: "ASSIGNED", label: "ASSIGNED", },
  { value: "RESCHEDULED", label: "RESCHEDULED", },
  { value: "PICKEDUP", label: "PICKED UP", },
  { value: "CLAIM", label: "CLAIM", },
  { value: "HOLD", label: "HOLD" },
  { value: "CANCELLED", label: "CANCELED", },
  { value: "COMPLETE", label: "COMPLETED", },
]

export const clearButtonStyle = {
  border: 'none',
  width: '90px',
  padding: '7px',
  borderRadius: '5px',
  background: 'linear-gradient(0deg, #E8E2E2, #E8E2E2), linear-gradient(0deg, #FFFFFF, #FFFFFF)'
}

export const applyButtonStyle = {
  border: 'none',
  width: '90px',
  padding: '7px',
  borderRadius: '5px',
  color: '#fff',
  background: 'linear-gradient(180deg, #55C416 0%, #367910 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)'
}

export const greenButton = {
  color: "white",
  border: 0,
  borderRadius: "5px",
  padding: "5px 15px",
  margin: "5px",
  background: "linear-gradient(to bottom,#61b01f 0%,#27911b 100%)",
}

export const noRecordStyle = {
  position: "absolute",
  width: "100%",
  textAlign: "center",
}